var _g, _g2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIFileDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2435_61345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48715 36.8457V7.28125H6.20312V40.1297H30.9201V36.8457H9.48715Z",
    fill: "#F4F6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2435_61345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48438 4V36.8485H34.2014V11.5193L26.6821 4H9.48438Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.199 11.5193L26.6797 4V11.5193H34.199Z",
    fill: "#F4F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5508 23.4452V19.0625H15.1114C15.5514 19.0625 15.9269 19.1505 16.2437 19.3265C16.5606 19.5025 16.807 19.7548 16.9771 20.0834C17.1473 20.4119 17.2353 20.7991 17.2353 21.2509C17.2353 21.7027 17.1473 22.0957 16.9771 22.4243C16.807 22.7529 16.5606 23.0051 16.2379 23.1811C15.9152 23.3572 15.5338 23.4452 15.0938 23.4452H13.5508ZM15.0586 22.6648C15.481 22.6648 15.7978 22.5475 16.0091 22.3187C16.2203 22.0899 16.3259 21.732 16.3259 21.2509C16.3259 20.7698 16.2203 20.4178 16.0091 20.189C15.7978 19.9602 15.481 19.8487 15.0586 19.8487H14.4543V22.6648H15.0527H15.0586Z",
    fill: "#82868C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6339 22.4557C21.4579 22.796 21.2115 23.0541 20.9064 23.2301C20.5954 23.4061 20.2493 23.5 19.8562 23.5C19.4631 23.5 19.1169 23.412 18.806 23.2301C18.495 23.0482 18.2545 22.7901 18.0726 22.4498C17.8966 22.1095 17.8086 21.7106 17.8086 21.2471C17.8086 20.7836 17.8966 20.3787 18.0726 20.0443C18.2486 19.704 18.495 19.4459 18.806 19.2699C19.1169 19.0939 19.469 19 19.8562 19C20.2434 19 20.5954 19.088 20.9064 19.2699C21.2173 19.4459 21.4579 19.7099 21.6339 20.0443C21.8099 20.3846 21.8979 20.7836 21.8979 21.2471C21.8979 21.7106 21.8099 22.1154 21.6339 22.4498V22.4557ZM20.836 20.4668C20.7421 20.2497 20.613 20.0854 20.4488 19.9739C20.2786 19.8625 20.085 19.8038 19.8562 19.8038C19.6274 19.8038 19.4279 19.8625 19.2636 19.9739C19.0935 20.0854 18.9644 20.2497 18.8705 20.4668C18.7767 20.6838 18.7297 20.9478 18.7297 21.2529C18.7297 21.558 18.7767 21.822 18.8705 22.0391C18.9644 22.2562 19.0935 22.4205 19.2636 22.5319C19.4338 22.6434 19.6274 22.7021 19.8562 22.7021C20.085 22.7021 20.2845 22.6434 20.4488 22.5319C20.6189 22.4205 20.748 22.2562 20.836 22.0391C20.924 21.822 20.9709 21.5639 20.9709 21.2529C20.9709 20.942 20.924 20.6838 20.836 20.4668Z",
    fill: "#82868C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3221 20.1675C25.2341 20.0502 25.1226 19.9622 24.9876 19.8977C24.8527 19.8331 24.7002 19.8038 24.53 19.8038C24.3012 19.8038 24.1017 19.8625 23.9316 19.9739C23.7614 20.0854 23.6324 20.2555 23.5385 20.4726C23.4446 20.6897 23.3977 20.9478 23.3977 21.2529C23.3977 21.558 23.4446 21.822 23.5385 22.0391C23.6324 22.2562 23.7614 22.4205 23.9316 22.5319C24.1017 22.6434 24.2953 22.6962 24.5242 22.6962C24.7764 22.6962 24.9876 22.6317 25.1578 22.4967C25.3279 22.3618 25.4394 22.1799 25.4805 21.9452H26.4016C26.3664 22.2269 26.2667 22.485 26.1082 22.7197C25.9498 22.9544 25.7269 23.1421 25.457 23.2888C25.1871 23.4355 24.8644 23.5 24.5124 23.5C24.1193 23.5 23.7673 23.412 23.4622 23.2301C23.1571 23.0482 22.9107 22.7901 22.7406 22.4557C22.5646 22.1154 22.4766 21.7164 22.4766 21.2471C22.4766 20.7777 22.5646 20.3787 22.7406 20.0443C22.9166 19.704 23.1571 19.4459 23.4681 19.2699C23.779 19.0939 24.1252 19 24.5124 19C24.8468 19 25.1519 19.0645 25.4277 19.1877C25.6976 19.311 25.9205 19.4928 26.0906 19.7334C26.2608 19.9739 26.3664 20.2555 26.4075 20.5841H25.4863C25.4629 20.4257 25.4042 20.2849 25.3221 20.1675Z",
    fill: "#82868C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6842 20.5703H28.7135L29.617 19.0625H30.6438L29.3061 21.2509L30.6731 23.4393H29.6229L28.7135 21.9315H28.6842L27.7748 23.4393H26.7305L28.1034 21.2509L26.7539 19.0625H27.7865L28.6842 20.5703Z",
    fill: "#82868C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2435_61345",
    x: 2.20312,
    y: 3.28125,
    width: 32.7188,
    height: 40.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2435_61345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2435_61345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2435_61345",
    x: 5.48438,
    y: 0,
    width: 32.7188,
    height: 40.8516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2435_61345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2435_61345",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFileDocx);
export default __webpack_public_path__ + "static/media/i_file_docx.9ce61d4139343fd4fb7d7d195a01a88c.svg";
export { ForwardRef as ReactComponent };